import {
    trigger, state, style, transition,
    animate, group, query, stagger, keyframes
} from '@angular/animations';

export enum EAnimationSlideInOutState {
    OUT = 'leave',
    IN = 'enter',
}

export const slideInOutAnimation = [
    trigger('contentExpansion', [
        transition(':enter', [
            style({height: '0px', visibility: 'hidden'}),
            animate('180ms cubic-bezier(.37,1.04,.68,.98)'),
            style({height: 100, visibility: 'visible'}),
        ]),
        transition(':leave', [
            animate('300ms cubic-bezier(.37,1.04,.68,.98)'),
            style({height: '0px', visibility: 'hidden'})
        ])
    ])
];
